// removed by extract-text-webpack-plugin
module.exports = {"colorPrimaryOrange":"#e16e46","colorWhite":"#ffffff","oldColorSilver":"#f6f6f6","colorBackground":"rgb(245, 244, 243)","smMargin":"32px","modal":"list__modal____1zDck","selected":"list__selected____3gTry","buttonListContainer":"list__buttonListContainer____30JXo","markdown":"list__markdown____2kUoL","box":"list__box____1i_cS","uppercase":"list__uppercase____vw6TY","imgScaleDown":"list__imgScaleDown____3yAVq","noBorder":"list__noBorder____3AJGV","noMargins":"list__noMargins____1DmsG","noLeftMargin":"list__noLeftMargin____37Rkz"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/common/list.css
// module id = 70
// module chunks = 0